<template>
  <div class="bg-container page">
    <div class="bg-wrapper">
      <div class="register">
        <van-nav-bar class="nav-bar">
          <template #left>
            <van-icon name="arrow-left" color="#c9a84c" @click="back()" />
          </template>
        </van-nav-bar>
        <div class="wrapper">
          <div class="logo-container">
            <div class="logo-wrapper">
              <img class="logo-img" :src="logoSrc" alt="logo" />
            </div>
          </div>
          <div class="title">{{ $t("auth.register") }}</div>
          <div class="loginForm">
            <van-field
              v-model="username"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.username_place')"
            />
            <van-field
              v-model="password"
              :type="passwordType"
              input-align="center"
              class="input"
              :placeholder="$t('auth.pwd_place')"
            >
              <template slot="right-icon">
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
                />
              </template>
            </van-field>
            <van-field
              v-model="code"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.invite_code_place')"
            />
            <van-button
              class="login-btn"
              type="primary"
              size="normal"
              @click="doRegister()"
              >{{ $t("auth.register") }}</van-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { resolveAssetUrl } from "../../http";
export default {
  data() {
    return {
      username: "",
      code: "",
      lang: "kr",
      password: "",
      passwordType: "password",
      logoSrc: "",
    };
  },
  beforeMount() {
    localStorage.setItem("lang", "kr");
    this.$i18n.locale = "kr";
  },
  mounted() {
    this.getBaseInfo();
  },
  methods: {
    getBaseInfo() {
      this.$http({ method: "get", url: "base_info" })
        .then((res) => {
          if (res && res.code === 200 && res.data) {
            this.$store.commit("setBaseInfoValue", res.data);
            if (res.data.ico) {
              this.logoSrc = resolveAssetUrl(res.data.ico);
            }
          }
        })
        .catch(() => {
          /* ignore */
        });
    },
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    doRegister() {
      if (!this.username) {
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if (!this.password) {
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if (!this.code) {
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }
      this.$http({
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          code: this.code,
          lang: this.lang,
        },
        url: "member_register",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          const token =
            res.data && res.data.id ? res.data.id : res.data;
          localStorage.setItem("token", token);
          this.$router.push("Mine");
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang="less" scoped>
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.bg-container {
  position: relative;
  bottom: 0;
  background: linear-gradient(-45deg, #1a1a1a, #000000);
  z-index: 2;
  min-height: 100vh;
  height: 100%;
}
.bg-container .bg-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(hsla(0, 0%, 0%, 0), #000000);
}
.register {
  height: 100%;
}
.bg-container .bg-wrapper .register .nav-bar {
  background: transparent !important;
  border-bottom: none !important;
}
.register .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.logo-container {
  margin: 0 auto;
  width: 45%;
}
.logo-container .logo-wrapper {
  position: relative;
  padding-bottom: 62.5%;
}
.logo-container .logo-wrapper .logo-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 0.8;
}
.register .wrapper .title {
  line-height: 13.333vw;
  text-align: center;
  font-size: 8vw;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.667vw;
}
.register .wrapper .loginForm {
  padding: 8vw;
}
.register .wrapper .loginForm .input {
  padding: 1.333vw 2.667vw;
  margin-top: 4.667vw;
  border-radius: 6.667vw;
  text-align: center;
  line-height: 9.333vw;
  font-size: 4vw;
  color: #4e4e4e;
  background: #141414 !important;
  border: none;
}
::v-deep .van-field__control {
  color: #4e4e4e !important;
}
::v-deep .van-cell::after {
  display: none;
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 5vw;
  color: #999;
}
.register .wrapper .loginForm .login-btn {
  margin-top: 4vw;
  width: 100%;
  height: 13.333vw;
  border-radius: 6.667vw;
  color: #fff !important;
  background-color: #c9a84c !important;
  font-size: 4vw;
  font-weight: bolder;
  border: none;
  box-shadow: 0 0 0.533vw #fff;
}
</style>
